import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import { MathHelper } from '../../../Utility/MathHelper';
import Point from '../../../Utility/Point';
import { delay } from '../../../Utility/Task/TaskQueue';
import { report } from '../../../report';

interface IPlayerIconHopParams {
    nextNode: GameObject;
}

export class PlayerIconHop extends AnimationClip<IPlayerIconHopParams> {
    public *execute(
        gameObject: GameObject,
        meta: IPlayerIconHopParams
    ): IterableIterator<number> {
        try {
            const duration: number = 750;

            const transform: TransformComponent = gameObject.getComponent(
                TransformComponent
            );
            const nextNodeTransform: TransformComponent = meta.nextNode.getComponent(
                TransformComponent
            );

            const bezierTween = this.getTween({ progress: 0 });

            const p1 = transform.position.clone() as Point;
            const p4 = nextNodeTransform.position.clone() as Point;
            const p2 = new Point((p1.x + p4.x) / 2, p1.y - 60);
            const p3 = new Point((p1.x + p4.x) / 2, p1.y - 60);

            yield* delay(500);

            bezierTween
                .to({ progress: 1 }, duration)
                .onUpdate(t => {
                    const xy = MathHelper.cubicBezier(t.progress, p1, p2, p3, p4);
                    transform.position.set(xy.x, xy.y);
                })
                .start(this.elapsedTime);

            yield* delay(duration - 100);

            yield* delay(500);
        } catch (error) {
            report('PlayerIconHop failed', { error, once: true });
        }
    }
}
